import React from 'react';
import useActionNetworkForm from '../../../hooks/useActionNetworkForm';

import './styles.scss';

const SingleForm = ({ block }) => {
  const { form } = block;
  const { formId } = useActionNetworkForm(form);

  return <div className="single-form-block">{form && <div id={formId} className="iframe-form" />}</div>;
};

export default SingleForm;
